import React from 'react';

import { Loading, LoadingIcon } from '@/src/globalComponents';
import { cn } from '@/src/util/ui';

import LoadingSpinner from './LoadingSpinner/LoadingSpinner';

import SectionCard from '../../Card/SectionCard/SectionCard';

export const LOADER_TYPE = {
  default: <Loading />,
  screen: <LoadingSpinner />,
  icon: <LoadingIcon />,
};

export const LOADER_POSITION = {
  relative: 'tw-relative ',
  absolute: 'tw-absolute tw-inset-0 tw-z-[5]',
};

type LoaderType = (typeof LOADER_TYPE)[keyof typeof LOADER_TYPE];

type SectionLoaderProps = {
  className?: string;
  spinnerClasses?: string;
  loaderType?: LoaderType;
  loaderPosition?;
};

const SectionLoader = ({
  className,
  spinnerClasses,
  loaderType = LOADER_TYPE.default,
  loaderPosition = LOADER_POSITION.relative,
}: SectionLoaderProps) => {
  return (
    <React.Fragment>
      {loaderType === LOADER_TYPE.default ? (
        <SectionCard
          className={cn('loaderSection--container', 'tw-pointer-events-none', className)}
        >
          <div className={cn('', className)} data-testid={'section-loader'}>
            {loaderType}
          </div>
        </SectionCard>
      ) : (
        <div
          className={cn(
            'loaderSection--container',
            'tw-pointer-events-none',
            'tw-w-full tw-h-full tw-min-h-full',
            loaderPosition,
            className
          )}
          data-testid={'section-loader'}
        >
          {React.cloneElement(loaderType, {
            spinnerClasses,
            isAbsolute: loaderPosition === LOADER_POSITION.absolute && loaderPosition,
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default SectionLoader;
